import { render, staticRenderFns } from "./IconOpen.vue?vue&type=template&id=36cf4580&scoped=true&"
import script from "./IconOpen.vue?vue&type=script&lang=js&"
export * from "./IconOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4580",
  null
  
)

export default component.exports